import { render, staticRenderFns } from "./OrgAppeals.vue?vue&type=template&id=213bf50c&scoped=true"
import script from "./OrgAppeals.vue?vue&type=script&lang=js"
export * from "./OrgAppeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213bf50c",
  null
  
)

export default component.exports